module.exports = __webpack_public_path__ + "static/media/expedia.6bd9b93a.png";